import React from 'react';
import PropTypes from 'prop-types';
import { Field, withFormik } from 'formik';
import Yup from 'yup';
import {
  GridContainer,
  GridItem,
  StaticFormLayout,
  TextFieldWrapper,
} from '../../common';

const NEW_PASSWORD = 'newPassword';
const CONFIRM_PASSWORD = 'confirmPassword';

function ResetPasswordForm({ email, ...rest }) {
  return (
    <StaticFormLayout {...rest} submitButtonText="Reset Password">
      <GridContainer spacing={24}>
        <GridItem xs={12}>
          <input
            autoComplete="username"
            hidden={true}
            readOnly={true}
            type="text"
            value={email}
          />
          <Field
            autoComplete="new-password"
            component={TextFieldWrapper}
            id={NEW_PASSWORD}
            label="New Password"
            name={NEW_PASSWORD}
            required
            type="password"
          />
        </GridItem>
        <GridItem xs={12}>
          <Field
            autoComplete="confirm-password"
            component={TextFieldWrapper}
            id={CONFIRM_PASSWORD}
            label="Confirm Password"
            name={CONFIRM_PASSWORD}
            required
            type="password"
          />
        </GridItem>
      </GridContainer>
    </StaticFormLayout>
  );
}

ResetPasswordForm.propTypes = {
  email: PropTypes.string.isRequired,
  onLogin: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  token: PropTypes.string.isRequired,
};

export default withFormik({
  displayName: 'ResetPasswordForm',
  enableReinitialize: true,
  handleSubmit: (values, { props, setStatus, setSubmitting }) => {
    return props
      .onSubmit({
        email: props.email,
        newPassword: values.newPassword,
        token: props.token,
      })
      .then(() => setStatus({ hasSaved: true, saveError: null }))
      .then(() => props.onLogin(props.email, values.newPassword))
      .catch(error => {
        setStatus({ saveError: error });
      })
      .finally(() => {
        setSubmitting(false);
      });
  },
  mapPropsToValues: () => {
    return {
      confirmPassword: '',
      newPassword: '',
    };
  },
  validationSchema: Yup.object({
    newPassword: Yup.string().required('New Password is required.'),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref('newPassword')], 'Passwords do not match.')
      .required('Confirm Password is required.'),
  }),
})(ResetPasswordForm);



// WEBPACK FOOTER //
// ./src/modules/ResetPasswordPage/components/ResetPasswordForm.js